import { render, staticRenderFns } from "./PointBitcashForm.vue?vue&type=template&id=04c31195"
import script from "./PointBitcashForm.vue?vue&type=script&lang=js"
export * from "./PointBitcashForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports